(function (angular) {
    'use strict';

    angular.module("branchReports")
        .controller("ViewMessageContentModalCtrl", ['$scope', '$uibModalInstance', 'messageData',
            function ($scope, $uibModalInstance, messageData) {

                $scope.messageData = messageData;

                var parts = [];

                if (messageData.message.body) {
                    parts.push({
                        data: messageData.message.body,
                        type: "text/plain"
                    });
                } else {
                    parts = messageData.message.messageParts;
                }

                $scope.parts = parts;

                $scope.close = function () {
                    $uibModalInstance.close();
                };

            }]);

})(window.angular);

